module.exports = __webpack_public_path__ + "img/more.13be3329.svg";